import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var AuthorInfo = styled.div.withConfig({
  displayName: "AuthorInfo",
  componentId: "sc-dc89q3-0"
})(["position:relative;flex:1;", ";"], function (_ref) {
  var small = _ref.small;
  return small ? getFont(-1) : getFont(0);
});